// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"957":"619960d1e0bc9ef2","4724":"b6323009d4472833","6325":"2ce79cb54183f141"}[chunkId] + ".css";
};